import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { NamePrefixModifier, withInjectedProps } from '../../../Core/InjectedPropsContext';
import { PageSection } from '../../../Layout';
import qestIds from '../../QestIds';
import { InitialSeatingReadingSection, LabMoistureContent } from '../Sections';
import { EquipmentDetailsSection, LoadIncrementsSection, PreparationSection, ResultsPageSection } from './Sections';

let CBRByPlateLoadingWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Preparation">
        <NamePrefixModifier appendNamePrefix="Preparation">
          <PreparationSection />
        </NamePrefixModifier>
        <NamePrefixModifier appendNamePrefix="Equipment">
          <EquipmentDetailsSection />
        </NamePrefixModifier>
      </PageSection>

      <InitialSeatingReadingSection />
      <LoadIncrementsSection />
      <NamePrefixModifier appendNamePrefix="LabMoistureContent">
        <LabMoistureContent />
      </NamePrefixModifier>

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>

      <ResultsPageSection />

      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

CBRByPlateLoadingWorksheet = withInjectedProps(CBRByPlateLoadingWorksheet);
CBRByPlateLoadingWorksheet.qestIds = [qestIds.plateLoading.InHouseMethod];

export default CBRByPlateLoadingWorksheet;
export { CBRByPlateLoadingWorksheet };
